/* iOrganic header 2026.
   Dawn's <sticky-header> custom element already owns stickiness and the
   hide-on-scroll-down / reveal-on-scroll-up behaviour (sticky_header_type =
   "on-scroll-up"). This script therefore does one thing only: it marks the
   header as "scrolled" so the CSS can condense its vertical padding and reveal
   the bottom hairline. It deliberately no longer translates the header itself,
   which previously fought Dawn's own transform/top handling.
   Styles live in assets/iorganic-tokens.css (Header 2026 block). */
(function () {
  var section =
    document.querySelector('.section-header') ||
    (document.querySelector('header.header') &&
      document.querySelector('header.header').closest('.shopify-section'));
  if (!section) return;

  var THRESHOLD = 8;
  var ticking = false;
  var isScrolled = null;

  function update() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var next = y > THRESHOLD;
    if (next === isScrolled) return;
    isScrolled = next;
    if (next) {
      section.classList.add('io-scrolled');
    } else {
      section.classList.remove('io-scrolled');
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  // Set the initial state (e.g. a reload part-way down the page).
  update();
})();
